import React from "react";
import { Testimonial } from "@scrile/api-provider/dist/api/TestimonialsProvider";
import "./style.scss";
import { MediaFilesController } from "lib/MediaFileController";

interface Props {
  item: Testimonial;
}

export default function TestimonialItem({ item }: Props) {
  const src =
    (item.avatar && MediaFilesController.getImageThumbnail(item.avatar.urlPart, "480p")) ||
    "/images/default-avatar.svg";
  return (
    <div className="testimonial-item box-shadow gap-6">
      <div className="testimonial-item__text-wrapper d-flex __column">
        <div className="testimonial-item__text caption-1 fw-bold">&quot;{item.text}&quot;</div>
        <div className="body-big">{item.name}</div>
        <div className="testimonial-item__role mt-1 body-1 fw-semibold">{item.role}</div>
        <div className="testimonial-item__background mt-1 body-3 text-neutral-darken-1">{item.background}</div>
      </div>
      <div className="testimonial-item__avatar" style={{ backgroundImage: `url(${src})` }}></div>
    </div>
  );
}
